
app.formsController = app.formsController || {};
app.formsController.defaultAction = {

    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        if ($('select').length > 0) {
            // Transform selects on no-touch devices
            $('select').customSelect();
        }

        if ($('[type="checkbox"]').length > 0) {
            this.transformCheck();
        }
        if ($('[type="radio"]').length > 0) {
            this.transformRadio();
        }
        if ($('[type="file"]').length > 0) {
            this.transformFile();
        }

        this.wpcf7Submit();
    },

    transformCheck : function () {
        $checkbox = $('[type="checkbox"]');
        $checkbox.each(function(){
            $check = $(this);
            $check.wrap('<span class="dummyCheck"></span>').after('<span class="dummySelected"></span>');
        });
    },

    transformRadio : function () {
        $radio = $('[type="radio"]');
        $radio.each(function(){
            $radio = $(this);
            $radio.wrap('<span class="dummyRadio"></span>').after('<span class="dummySelected"></span>');
        });
    },

    transformFile : function () {
        var $fileFld = $('.customFile');
        if ($fileFld.length > 0) {
            $fileFld.each(function() {
                var $file = $(this),
                    $fileName = $file.find('.fileBtn'),
                    $fileInput = $file.find('input');
                $fileInput.on('change', function() {
                    $fileName.text($fileInput.val());
                });
            });
        }
    },

    wpcf7Submit : function() {
        if ($('.fld-confirm-email').length > 0) {
            $('.wpcf7-submit').click(function () {
                // We remove the error to avoid duplicate errors
                jQuery('.error-email').remove();
                // We create a variable to store our error message
                var errorMsg = jQuery('<span class="error wpcf7-not-valid-tip error-email">Les emails ne correspondent pas.</span>');
                // Then we check our values to see if they match
                // If they do not match we display the error and we do not allow form to submit
                if (jQuery('.fld-email').find('input').val() !== jQuery('.fld-confirm-email').find('input').val()) {
                    errorMsg.insertAfter(jQuery('.fld-confirm-email').find('input'));
                    return false;
                } else {
                    // If they do match we remove the error and we submit the form
                    jQuery('.error-email').remove();
                    return true;
                }
            });
        }

        $(".wpcf7").on('wpcf7:submit', function(event){

            // 2. ADD ERROR CLASS ON CUSTOM FILE
            if ($('.customFile').length > 0) {
                $('.customFile [aria-invalid="true"]').parents('.customFile').find('.fldCustom').addClass('aria-invalid');
                $('.customFile [aria-invalid="false"]').parents('.customFile').find('.fldCustom').removeClass('aria-invalid');
            }

            // 3. ADD ERROR CLASS ON CUSTOM CHECKBOX/RADIO
            if ($('.dummyRadio').length > 0) {
                $('.dummyRadio [aria-invalid="true"]').parents('.dummyRadio').find('.fldCustom').addClass('aria-invalid');
                $('.dummyRadio [aria-invalid="false"]').parents('.dummyRadio').find('.fldCustom').removeClass('aria-invalid');
            }
        });
    },

};

document.addEventListener( 'wpcf7mailsent', function( event ) {
    console.log(event);
  window.location.href = 'https://www.hovia.fr/lorganisation/recrutement/merci/';
}, false );

$(document).ready(function(){
    app.formsController.defaultAction.init();
});
